import React, { useState } from "react";
import icons from "../../utils/Icons";
import axios from "axios";
import CONFIG from "../../utils/Config";
import ShiftingCountdown from "./Timer";
import {useClient} from "../../utils/context/ClientContext";
import PrinterIcon from "../../utils/icons/PrinterIcon";

const OrderDetails = (props) => {
  let { orderId, orderTime, orderData } = props; 
  const [loading, setLoading] = useState(false);
  const { tenant } = useClient();

  const downloadReceipt = () => {
    let tokenId = sessionStorage.getItem("tokenId");
    setLoading(true)
    axios({
      url: CONFIG.URL + "public/client/downloadReceipt",
      method:"POST",
      responseType: 'blob',
      headers: {
        'X-TenantID': tenant
      },
      params:{
        'tokenId':tokenId,
        'orderId':props.orderId
      }
    }).then((res) => {
      const href = URL.createObjectURL(res.data);      
      const link = document.createElement('a');
      link.href = href;    
      let fileName = res.headers.get('Content-Disposition') ;      
      link.setAttribute('download', props.orderId+".pdf");      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);    
      setLoading(false)  
    }).catch((err) => {
      alert("Download Failed!")
      setLoading(false);
      console.error(err);
    })
    
  }

  return (
    <>
      <div className="w-full mx-auto h-auto p-6 md:p-10 border rounded-2xl mb-3 shadow-lg bg-white text-blue-gray-800">
        <div className="flex justify-between items-start">
          <div className="grid-flow-row ">
            <h3 className="font-primary-medium text-gray-900 text-sm md:text-base mb-0.5">
              Order Details:
            </h3>
            <h3 className="font-gotham-semibold">#{orderId}</h3>
            <h3 className="font-gotham-regular text-base">{orderTime}</h3>
          </div>

          <div className=" text-sm  text-gray-700">
            <p className="font-primary-semibold">Estimated delivery time:</p>
            <div className=" border-2 border-emerald-500 my-1  bg-emerald-50 rounded-lg  text-xs py-1 text-left">
              <ShiftingCountdown distance={1800000} type={2} />
            </div>
          </div>
        </div>
        <div className="my-3 text-sm md:text-base mt-7 ">
          <div className="text-blue-gray-900 *:font-semibold">
            <div className="grid grid-cols-4">
              <p className="px-2 py-4 line-clamp-1  whitespace-nowrap ">Item</p>
              <div className="px-2 py-4 justify-center flex">
                <p className="mx-4">Quantity</p>
              </div>
              <p className="px-2 py-4 text-center ">Rate</p>
              <p className="px-2 py-4 text-right ">Amount</p>
            </div>
          </div>
          <hr />
          {orderData.bill.billDetails.length > 0 ? (
            orderData.bill.billDetails.map((e) => (
              <>
                <div className="grid grid-cols-4  ">
                  <p className="px-2 py-4 line-clamp-1 w-40 font-primary-regular text-gray-900">
                    {e.product.name}
                  </p>
                  <p className="px-2 py-4 text-center font-gotham-regular text-gray-700">
                    {e.quantity}
                  </p>
                  <p className="px-2 py-4 text-center font-gotham-medium text-gray-700">
                    {e.product.rate}
                  </p>
                  <p className="px-2 py-4 text-right font-gotham-medium text-gray-900">
                    {e.amount}
                  </p>
                </div>
                <hr />
              </>
            ))
          ) : (
            <></>
          )}
          <hr />
          <div className="grid mx-2">
            <p className="col-start-3 py-4 text-center text-gray-700 font-primary-bold">
              Total
            </p>
            <p className="col-start-4 py-4 text-right font-gotham-semibold text-gray-900">
              {orderData != null ? orderData.amount : 0}
            </p>
          </div>
          <div className="my-6">
            <button
              onClick={downloadReceipt}
              className="font-primary-regular mx-auto text-white py-2 px-2 bg-primary hover:bg-primary-hover rounded-lg shadow-lg cursor-pointer flex items-center gap-2"
            >
             {!loading ? <PrinterIcon className={"w-6 h-6 fill-gray-50"}/>:<svg
                  aria-hidden="true"
                  className=" w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 bg-primarys"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg> }
              Download Receipt
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderDetails;
